angular.module('bizmetryApp').controller('JobDefinitionsDialogController', function (
  $scope, $mdDialog, jobService, $interval
) {
  $scope.loading = true;
  $scope.jobs = [];
  $scope.filteredJobs = [];
  $scope.searchQuery = '';
  $scope.expandedJobId = null;

  var previousFailedRuns = {};
  var autoRefreshInterval = null;

  // ===== SEARCH =====
  // Client-side, not debounced — the full job list is already loaded up
  // front (getAllJobDefinitions has no pagination), so there's no request
  // to throttle the way BizInterceptorsTabController's own server-side
  // search debounces its own API calls.

  function applySearch() {
    var q = ($scope.searchQuery || '').trim().toLowerCase();
    if (!q) {
      $scope.filteredJobs = $scope.jobs;
      return;
    }
    $scope.filteredJobs = $scope.jobs.filter(function (job) {
      return (job.jobName && job.jobName.toLowerCase().indexOf(q) > -1) ||
        (job.jobDescription && job.jobDescription.toLowerCase().indexOf(q) > -1) ||
        (job.jobId && job.jobId.toLowerCase().indexOf(q) > -1) ||
        (job.className && job.className.toLowerCase().indexOf(q) > -1);
    });
  }

  $scope.onSearchChange = function () {
    applySearch();
  };

  $scope.clearSearch = function () {
    $scope.searchQuery = '';
    applySearch();
  };

  // ===== INIT =====

  jobService.getAllJobDefinitions()
    .then(function (response) {
      $scope.jobs = response.data;
      applySearch();

      $scope.jobs.forEach(function(job) {
        previousFailedRuns[job.jobId] = job.failedRuns || 0;
      });

      console.log('✅ Loaded', $scope.jobs.length, 'job definitions');
      startAutoRefresh();
    })
    .catch(function (error) {
      console.error('❌ Error al obtener definiciones de jobs:', error);
    })
    .finally(function () {
      $scope.loading = false;
    });

  // ===== DETAIL PANEL =====

  /**
   * Abre/cierra el panel de detalles de un job (solo uno a la vez)
   */
  $scope.toggleDetails = function(job) {
    if ($scope.expandedJobId === job.jobId) {
      $scope.expandedJobId = null;
    } else {
      $scope.expandedJobId = job.jobId;
    }
  };

  // ===== STATS CALCULATIONS =====

  /**
   * Cuenta cuántos jobs están habilitados
   */
  $scope.getEnabledJobsCount = function() {
    if (!$scope.jobs || $scope.jobs.length === 0) return 0;
    return $scope.jobs.filter(function(job) {
      return job.enabled === true;
    }).length;
  };

  /**
   * Suma total de ejecuciones de todos los jobs
   */
  $scope.getTotalRuns = function() {
    if (!$scope.jobs || $scope.jobs.length === 0) return 0;
    return $scope.jobs.reduce(function(sum, job) {
      return sum + (job.totalRuns || 0);
    }, 0);
  };

  /**
   * Suma total de fallos de todos los jobs
   */
  $scope.getTotalFailures = function() {
    if (!$scope.jobs || $scope.jobs.length === 0) return 0;
    return $scope.jobs.reduce(function(sum, job) {
      return sum + (job.failedRuns || 0);
    }, 0);
  };

  /**
   * Porcentaje de éxito global
   */
  $scope.getSuccessRate = function() {
    var totalRuns     = $scope.getTotalRuns();
    var totalFailures = $scope.getTotalFailures();
    if (totalRuns === 0) return 100;
    return (((totalRuns - totalFailures) / totalRuns) * 100).toFixed(1);
  };

  /**
   * Porcentaje de éxito para un job individual
   */
  $scope.getSuccessRateForJob = function(job) {
    if (!job || job.totalRuns === 0) return 100;
    return (((job.totalRuns - job.failedRuns) / job.totalRuns) * 100).toFixed(1);
  };

  /**
   * Determina si un job tiene errores recientes (failedRuns incrementó desde el último refresh)
   */
  $scope.hasRecentErrors = function(job) {
    if (!job || !job.jobId) return false;
    return (job.failedRuns || 0) > (previousFailedRuns[job.jobId] || 0);
  };

  /**
   * Cuántos errores nuevos tiene el job desde el último refresh
   */
  $scope.getNewFailuresCount = function(job) {
    if (!job || !job.jobId) return 0;
    return Math.max(0, (job.failedRuns || 0) - (previousFailedRuns[job.jobId] || 0));
  };

  // ===== REFRESH =====

  /**
   * Refresca las definiciones de jobs
   * @param {boolean} isManualRefresh - true muestra el spinner
   */
  $scope.refreshJobs = function(isManualRefresh) {
    if (isManualRefresh) {
      $scope.loading = true;
    }

    var scrollContainer = document.querySelector('.jobs-content');
    var scrollPosition  = scrollContainer ? scrollContainer.scrollTop : 0;

    jobService.getAllJobDefinitions()
      .then(function (response) {
        var newJobs = response.data;

        newJobs.forEach(function(job) {
          var previousCount = previousFailedRuns[job.jobId] || 0;
          var currentCount  = job.failedRuns || 0;

          if (currentCount > previousCount) {
            console.log('⚠️ Job', job.jobName, 'has new failures:',
              currentCount - previousCount, 'new errors');
          }

          previousFailedRuns[job.jobId] = currentCount;
        });

        $scope.jobs = newJobs;
        applySearch();
        console.log('🔄 Jobs refreshed');

        $scope.$applyAsync(function() {
          if (scrollContainer) {
            scrollContainer.scrollTop = scrollPosition;
          }
        });
      })
      .catch(function (error) {
        console.error('❌ Error refreshing jobs:', error);
      })
      .finally(function () {
        if (isManualRefresh) {
          $scope.loading = false;
        }
      });
  };

  // ===== AUTO-REFRESH =====

  function startAutoRefresh() {
    if (autoRefreshInterval) {
      $interval.cancel(autoRefreshInterval);
    }

    autoRefreshInterval = $interval(function() {
      console.log('🔄 Auto-refreshing jobs...');
      $scope.refreshJobs(false);
    }, 10000);

    console.log('✅ Auto-refresh started (every 10 seconds)');
  }

  function stopAutoRefresh() {
    if (autoRefreshInterval) {
      $interval.cancel(autoRefreshInterval);
      autoRefreshInterval = null;
      console.log('⏹️ Auto-refresh stopped');
    }
  }

  // ===== DIALOG ACTIONS =====

  $scope.close = function () {
    stopAutoRefresh();
    $mdDialog.hide();
  };

  /**
   * Abre el diálogo de instancias para un job específico
   */
  $scope.openJobInstances = function(job, $event) {
    console.log('📊 Opening instances for job:', job.jobName);

    $mdDialog.show({
      controller: 'JobInstancesDialogController',
      templateUrl: 'home/main-menu/jobs/job-instances-dialog.html',
      parent: angular.element(document.body),
      escapeToClose: false,
      targetEvent: $event,
      clickOutsideToClose: true,
      multiple: true,
      fullscreen: true,
      locals: {
        jobDefinition: job
      }
    }).then(function() {
      console.log('✅ Job instances dialog closed');
      $scope.refreshJobs(false);
    }).catch(function() {
      console.log('❌ Job instances dialog cancelled');
    });
  };

  // ===== CLEANUP =====

  $scope.$on('$destroy', function() {
    stopAutoRefresh();
    console.log('🧹 JobDefinitionsDialog cleaned up');
  });

});

// ===== FILTERS =====

/**
 * Convierte milisegundos a formato legible: Xh Ym / Xm Ys / Xms
 * Uso: {{ job.totalTimeTaken | msToHoursMin }}
 *
 * Ejemplos:
 *   15,673,443 ms → "4h 21m"
 *      125,000 ms → "2m 5s"
 *          842 ms → "842 ms"
 */
angular.module('bizmetryApp').filter('msToHoursMin', function() {
  return function(ms) {
    if (!ms || ms <= 0) return '—';

    var totalSeconds = Math.floor(ms / 1000);
    var totalMinutes = Math.floor(totalSeconds / 60);
    var totalHours   = Math.floor(totalMinutes / 60);

    if (totalHours > 0) {
      var remainingMinutes = totalMinutes % 60;
      return totalHours + 'h ' + remainingMinutes + 'm';
    }

    if (totalMinutes > 0) {
      var remainingSeconds = totalSeconds % 60;
      return totalMinutes + 'm ' + remainingSeconds + 's';
    }

    return totalSeconds > 0 ? totalSeconds + 's' : ms + ' ms';
  };
});